export default __webpack_public_path__ + "static/sunburst-59710784819fa9e12170607467b789c7.png";